import React from 'react';
import PropTypes from 'prop-types';
import { Draggable } from 'react-beautiful-dnd';

import NewTileComponent from '../TileComponent/NewTileComponent.jsx';
import { useTileView } from '../../lib/redux/hooks/useTileView';

const DraggableTile = ({
  id,
  index,
  thumbnail,
  embedVideo,
  headline,
  date,
  planDate,
  calendarClass,
  audienceColor,
  tileContainerClass,
  tileThumblinkClass,
  shadowOverlayButtons,
  popdownMenu,
  loading,
  tileStats,
  ignored,
  ribbonTagColor,
  ribbonTagName,
}) => {
  const { setTileView } = useTileView();

  const openTile = () => {
    const tab = window.location.hash.replace('#tab-', '');

    setTileView({ tileId: id, currentTab: tab });
  };

  return (
    <Draggable draggableId={id} index={index}>
      {provided => (
        <div
          className={`tile_container ${tileContainerClass}`}
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          <NewTileComponent
            id={id}
            headline={headline}
            thumbnail={thumbnail}
            embedVideo={embedVideo}
            date={date}
            planDate={planDate}
            calendarClass={calendarClass}
            audienceColor={audienceColor}
            tileContainerClass={tileContainerClass}
            tileThumblinkClass={tileThumblinkClass}
            shadowOverlayButtons={shadowOverlayButtons}
            popdownMenu={popdownMenu}
            loading={loading}
            tileThumblinkOnClick={openTile}
            draggable={true}
            tileStats={tileStats}
            ignored={ignored}
            ribbonTagColor={ribbonTagColor}
            ribbonTagName={ribbonTagName}
            copyButtonDisplay={false}
            viewButtonDisplay={true}
            shadowOverlay={false}
          />
        </div>
      )}
    </Draggable>
  );
};

DraggableTile.propTypes = {
  id: PropTypes.string,
  index: PropTypes.number,
  thumbnail: PropTypes.string,
  embedVideo: PropTypes.any,
  headline: PropTypes.string,
  date: PropTypes.string,
  planDate: PropTypes.string,
  calendarClass: PropTypes.string,
  audienceColor: PropTypes.string,
  tileContainerClass: PropTypes.string,
  tileThumblinkClass: PropTypes.string,
  shadowOverlayButtons: PropTypes.array,
  popdownMenu: PropTypes.element,
  loading: PropTypes.bool,
  ignored: PropTypes.bool,
  tileThumblinkOnClick: PropTypes.func,
  tileStats: PropTypes.object,
  ribbonTagName: PropTypes.string,
  ribbonTagColor: PropTypes.string,
};

export default DraggableTile;
